import { addStyles } from 'ethcss'
import { IStyles } from 'theme'

export const styles: IStyles = {
    optionWrapper: {
        marginBottom: 20,
    },
    input: {
        width: 400,
    },
    optionCaption: {
        marginBottom: 10,
    },
    titleWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 14,
    },
    title: {
        marginRight: 10,
    },
    checkboxLabel: {
        fontSize: 14,
    },
}

addStyles(styles)
